import chevronLeftBlack from "images/layout/chevron-left-black.svg"

import "./header.scss"
interface Props {
  onClickBack: () => void
  title: string | object
}

const Header = ({ onClickBack, title }: Props) => (
  <header styleName="onboarding-header">
    <button
      type="submit"
      styleName="back"
      className="back-button-fixed button-tertiary button-outlined button-with-icon only-icon-on-mobile"
      aria-label="Back button"
      onClick={() => {
        onClickBack()
      }}
    >
      <span
        className="button-icon"
        dangerouslySetInnerHTML={{
          __html: chevronLeftBlack,
        }}
      />
      <span className="hide-on-xs">Back</span>
    </button>
    <div styleName="spacer" />
    <h1>{title}</h1>
    <div styleName="spacer" />
  </header>
)

export default Header
